module.exports = __webpack_public_path__ + "img/icon_money.f5265957.svg";